export enum MessageConstants {
    NoMoney = 'Нет средств',
    WrongPasswords = 'Пароли не совпадают!',
    DataChanged = 'Данные изменены',
    SendedToMail = 'Письмо для подтверждения отправлено на новый адрес',
    DeleteConfirmation = 'Вы уверены, что хотите удалять аккаунт? Восстановление аккаунта возможно только через администрацию сайта',
    WrongMail = 'Неверный формат почты!',
    WrongLength = 'Длина названия должна быть от 1 до 60 символов!'

}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/MessageConstants.ts